import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-brand">
          <div className="brand-logo">
            <div className="logo-icon">
              <img src="/logo.png" alt="Fital Platform Logo" />
            </div>
            <h3 className="brand-name">منصة فتل</h3>
          </div>
          <h4 className="section-title">نبذة</h4>
          <p className="mission-text">
            نهدف إلى خلق شراكات مستدامة بين وكالات التسويق وأصحاب المشاريع، لنصنع معاً قصص نجاح ملهمة.
          </p>
          <div className="social-icons">
            <a href="#" className="social-icon">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="social-icon">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-icon">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="#" className="social-icon">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>

        {/* Links Sections Container */}
        <div className="footer-links-container">
          {/* About Links Section */}
          <div className="footer-links">
            <h4 className="section-title">نبذة</h4>
            <ul className="links-list">
              <li><a href="#about">من نحن</a></li>
              <li><a href="#mission">الرسالة والقيم</a></li>
              <li><a href="#terms">الشروط والأحكام</a></li>
              <li><a href="#contact">تواصل</a></li>
            </ul>
          </div>

          {/* Services Links Section */}
          <div className="footer-links">
            <h4 className="section-title">لأصحاب المشاريع ومقدمي الخدمات</h4>
            <ul className="links-list">
              <li><a href="#how-it-works">كيف تعمل المنصة</a></li>
              <li><a href="#publish">النشر</a></li>
              <li><a href="#terms">الشروط والأحكام</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
